'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M576 736l96 96 320-320-320-320-96 96 224 224z' }),
        React.createElement('path', { d: 'M448 288l-96-96-320 320 320 320 96-96-224-224z' })
    ));
};